module.exports = __webpack_public_path__ + "6f190f1631f58892164ec72f1ebf1459.png";